import React from 'react';
import get from 'lodash.get';
import { defineMessages, FormattedMessage } from 'react-intl';
import { of } from 'rxjs';

import { NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_INFO } from 'ui-components/services/notification-service';

import { DocumentType } from '../../../enums/document-type';
import * as ConnectActions from '../../../store/shipstation-connect/ss-connect.actions';

const messages = defineMessages({
  printingLocationBarcodeSuccessTitle: {
    description: 'Printing Location Barcode Success Title',
    defaultMessage: 'Printing {docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}}...',
    id: 'j6k5YN',
  },
  printingLocationBarcodeSuccessContent: {
    description: 'Printing Location Barcode Success Content',
    defaultMessage: '{docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}} sent to {printerName}.',
    id: 'tGRbE1',
  },
  downloadLocationBarcodeStartedTitle: {
    description: 'Download Location Barcode Started Title',
    defaultMessage: 'Downloading {docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}}...',
    id: 'Ut9vIk',
  },
  downloadLocationBarcodeStartedContent: {
    description: 'Download Location Barcode Started Content',
    defaultMessage: '{docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}} Download Started.',
    id: 'WFQvC9',
  },
  downloadLocationBarcodeCompletedTitle: {
    description: 'Download Location Barcode Completed Title',
    defaultMessage: 'Downloading {docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}}...',
    id: 'ZggnPj',
  },
  downloadLocationBarcodeCompletedContent: {
    description: 'Download Location Barcode Completed Content',
    defaultMessage: '{docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}} Download Completed.',
    id: 'v/+XKx',
  },
  asyncPrintLocationBarcodeStartedContent: {
    description: 'Notification message shown when generating location barcodes',
    defaultMessage: 'We are generating your {docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}}.',
    id: 'q1KlM2',
  },
  asyncPrintLocationBarcodeFailedContent: {
    description: 'Notification message shown when generating location barcodes fails',
    defaultMessage:
      'Failed to generate {docCount, plural,=0 {Location Barcode} one {Location Barcode} other {Location Barcodes}}. Please try again.',
    id: '0iSsHf',
  },
});

export const locationBarcode = {
  id: DocumentType.LocationBarcode.identifier,

  getDownloadStartedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadLocationBarcodeStartedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadLocationBarcodeStartedContent} values={{ docCount }} />,
  }),

  getDownloadCompletedProps: (docCount) => ({
    title: <FormattedMessage {...messages.downloadLocationBarcodeCompletedTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.downloadLocationBarcodeCompletedContent} values={{ docCount }} />,
  }),

  getPrintedSuccessNotificationProps: (docCount, printerName) => ({
    title: <FormattedMessage {...messages.printingLocationBarcodeSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.printingLocationBarcodeSuccessContent} values={{ docCount, printerName }} />,
  }),

  getAsyncPrintStartedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingLocationBarcodeSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintLocationBarcodeStartedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_INFO,
  }),

  getAsyncPrintFailedNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingLocationBarcodeSuccessTitle} values={{ docCount }} />,
    content: <FormattedMessage {...messages.asyncPrintLocationBarcodeFailedContent} values={{ docCount }} />,
    notificationType: NOTIFICATION_TYPE_ERROR,
    duration: NOTIFICATION_DURATIONS.MEDIUM,
  }),

  getPrintedSuccessObservable: (printJob) => {
    const printJobRequestId = get(printJob, 'requestId');
    return of(ConnectActions.printDocumentComplete(printJobRequestId));
  },
};
